import React from 'react';

import classes from './RoundButton.css'
import Icon from '../Icons/index';

const roundButton = (props) => {
  let buttonClass = [classes.RoundButton]
 
  if (props.disabledButton) {
    buttonClass = [classes.RoundButton, classes.RoundButtonDisabled]
  }

  return (
    <button
      className={buttonClass.join(' ')}
      onClick={props.clicked}
      disabled={props.disabledButton}>
        <Icon fill={props.fill} name={props.name} />
      </button>
  );
};

export default roundButton;


// WEBPACK FOOTER //
// ./src/components/UI/RoundButton/RoundButton.js